import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Index from '../../components/pages/listing';
import Profile from './profile';
import Upload from './upload';

import { useGlobalStore } from '../../lib/store';

const fieldsToDisplay = [
  'in_charge',
  'print_number',
  'chassis_number',
  'mvmd_remarks',
  'district',
  'usage',
  'purpose',
  'type',
  'type_detail',
  'make',
  'maintainance',
  'maintainance_remarks',
  'maintenance_mileage',
  'maintainance_end_date',
  'vehicle_class',
  'license',
  'vehicle_model',
  'engine_number',
  'cylinder_capacity',
  'color',
  'body_type',
  'gross_vehicle_weight',
  'registered_owner',
  'owner_registration_date',
  'manufacture_year',
  'first_registration_date',
  'rearview_mirror',
  'spare_key',
  'new_car',
  'gratia_payment_scheme',
  'car_loan',
  'remarks',
];

function Page({ mode, prefix, title, sidebarItem, newEntry, titleIcon }) {
  const { _id } = useParams();
  const { setActiveSidebarItem } = useGlobalStore();
  useEffect(() => {
    setActiveSidebarItem(sidebarItem);
  }, []);
  const isHome = mode === 'home';
  const isImport = mode === 'import';

  return (
    <div>
      {isHome ? (
        <Index
          prefix={prefix}
          title={title}
          newEntry={newEntry}
          titleIcon={titleIcon}
          defaultSort={{ field: 'current_reg_mark', order: 'asc' }}
          downloadable={true}
        />
      ) : isImport ? (
        <Upload
          prefix={prefix}
          title={title}
          fieldsToDisplay={fieldsToDisplay}
          titleIcon={titleIcon}
        />
      ) : (
        <Profile
          _id={_id}
          mode={mode}
          prefix={prefix}
          title={title}
          titleIcon={titleIcon}
        />
      )}
    </div>
  );
}

export default Page;
